enum Events {
  ActiveTrade = 'finance|active-trade',
  /** @deprecated */
  CkPromoModalOpen = 'vdp|ck-promo-modal|open',
  EstimatedAmountFinanced = 'finance|estimated-amount-financed',
  Geolocation = 'vdp|geolocation',
  GetStarted = 'vdp|get-started',
  HeaderAccountModalClose = 'header|account-modal|close',
  HeaderAccountModalOpen = 'header|account-modal|open',
  FinanceIsError = 'finance|is-error',
  FinanceIsLoading = 'finance|is-loading',
  IsTradeInApplied = 'finance|is-trade-in-applied',
  UserFinancing = 'finance|user-financing',
  UserProfile = 'vdp|user-profile'
}

export default Events;
